import React from 'react'
import PropTypes from 'prop-types'

export function PhoneTypeSelector({ types, selectedId, onSelect }) {
  return (
    <div className="phone-type-options">
      {types.map(type => (
        <button
          key={type.id}
          type="button"
          className={`phone-type-option${
            selectedId === type.id ? ' phone-type-selected' : ''
          }`}
          onClick={() => onSelect(type.id)}>
          {type.icon}
          <span>{type.label}</span>
        </button>
      ))}
    </div>
  )
}

PhoneTypeSelector.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      icon: PropTypes.node,
    })
  ).isRequired,
  selectedId: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
}
